import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  label: string
  name: string
}

const YesNo = ({ label, name }: Props) => {
  return (
    <div>
      <p className="font-medium my-5">{label}</p>
      <div className="radio-btn-container flex mb-5">
        <RadioButton name={name} label="Yes" value={true} errorDisabled />
        <RadioButton name={name} label="No" value={false} errorDisabled />
      </div>
    </div>
  )
}

export default YesNo
